import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {PreferableRouteResponse} from './preferable-route/model/preferable-route.response';
import {PreferableRouteDetailsEntry} from './preferable-route/model/preferable-route-details.entry';

@Injectable()
export class RouteStateService {

  private preferableRouteCreationSource = new Subject<void>();
  private preferableRouteCreation$ = this.preferableRouteCreationSource.asObservable();

  private routeDataSource = new Subject<Map<string, PreferableRouteResponse>>();
  private routeData$ = this.routeDataSource.asObservable();

  private clearMapSource = new Subject<void>();
  private clearMap$ = this.clearMapSource.asObservable();

  private activeFormSource = new Subject<string>();
  private activeForm$ = this.activeFormSource.asObservable();

  private drawRouteSource = new Subject<PreferableRouteDetailsEntry[]>();
  private drawRoute$ = this.drawRouteSource.asObservable();

  private drawReversedRouteSource = new Subject<{data: PreferableRouteResponse, type: string}>();
  private drawReversedRoute$ = this.drawReversedRouteSource.asObservable();

  private clearRouteDetailsSource = new Subject<string>();
  private clearRouteDetails$ = this.clearRouteDetailsSource.asObservable();

  private resetRouteSource = new Subject<string>();
  private resetRoute$ = this.resetRouteSource.asObservable();

  private redrawRouteSource = new Subject<any>();
  private redrawRoute$ = this.redrawRouteSource.asObservable();

  public initPreferableRouteCreation(): void {
    this.preferableRouteCreationSource.next();
  }

  public initPreferableRouteCreationListener(): Observable<void> {
    return this.preferableRouteCreation$;
  }

  public transferRouteData(type: string, data: PreferableRouteResponse): void {
    this.routeDataSource.next(new Map<string, PreferableRouteResponse>().set(type, data))
  }

  public transferRouteDataListener(): Observable<Map<string, PreferableRouteResponse>> {
    return this.routeData$;
  }

  public clearMap(): void {
    this.clearMapSource.next();
  }

  public clearMapListener(): Observable<void> {
    return this.clearMap$;
  }

  public triggerActiveForm(formType: string): void {
    this.activeFormSource.next(formType);
  }

  public activeFormListener(): Observable<string> {
    return this.activeForm$;
  }

  public triggerDrawRoute(routes: PreferableRouteDetailsEntry[]): void {
    this.drawRouteSource.next(routes);
  }

  public drawRouteListener(): Observable<PreferableRouteDetailsEntry[]> {
    return this.drawRoute$;
  }

  public triggerInitReversedRoute(reversedRoute: PreferableRouteResponse, type: string): void {
    this.drawReversedRouteSource.next({data: reversedRoute, type: type});
  }

  public initReversedRoute(): Observable<{data: PreferableRouteResponse, type: string}> {
    return this.drawReversedRoute$;
  }

  public triggerClearRouteDetails(type: string): void {
    this.clearRouteDetailsSource.next(type)
  }

  public clearRouteDetails(): Observable<string> {
    return this.clearRouteDetails$;
  }

  public resetRoute(type: string): void {
    this.resetRouteSource.next(type);
  }

  public triggerRouteReset(): Observable<string> {
    return this.resetRoute$;
  }

  public redrawRoute(data: any): void {
    this.redrawRouteSource.next(data);
  }

  public triggerRedrawRoute(): Observable<any> {
    return this.redrawRoute$;
  }

}
